import React, { useEffect, useState } from 'react';
import { useApiAppointments } from '../../../../api/api.appoiments';
import { EstadoCita, ExtendedAppointmentFormData, SysI_Agenda } from '../../../../types/types.agendaCitas';
import { newToast } from '../../../../components';
import AppointmentForm from '../../../AdminAgendaCitas/Components/AppointmentForm';
import moment from 'moment';

export const ModalCreateAppointment = ({ visible, setVisible, patientId, patientDocument, quotationId, preorderId }) => {
  const [appointmentFormData, setAppointmentFormData] = useState<any>(null);  

  const [isSearchingPatient, setIsSearchingPatient] = useState(false);
  const [patientFound, setPatientFound] = useState(false);

  // API para agendas y citas
  const { getAgendas, createCita } = useApiAppointments();
  const [agendas, setAgendas] = useState<SysI_Agenda[]>([]);

  // Cargar agendas al montar el componente (o cuando sea necesario)
  useEffect(() => {
    const loadAgendas = async () => {
      try {
        const agendasData = await getAgendas();
        // Filtrar solo las agendas activas
        const activeAgendas = agendasData.filter((agenda) => agenda.Ag_Estado === true);
        setAgendas(activeAgendas);
      } catch (error) {
        console.error('Error al cargar agendas:', error);
      }
    };

    loadAgendas();
  }, []);

  useEffect(() => {
    if (visible) {
      handleOpenAppointmentForm({
        patientId: patientId,
        patientDocument: patientDocument || '',
      });
    }
  }, [visible]);

  // Función para abrir el formulario de citas con los datos del paciente y la cotización
  const handleOpenAppointmentForm = (patientData) => {
    // Resetear el formulario
    const startDate = moment(new Date()).add(3, 'minutes').toDate();   
    const endDate = moment(startDate).add(30, 'minutes').toDate(); 
    setAppointmentFormData({
      agendaId: null,
      patientId: patientData.patientId || null,
      patientDocument: patientData.patientDocument || '',
      patientName: '',
      patientLastName: '',
      patientGender: null,
      patientBirthDate: null,
      startDate: startDate,
      endDate: endDate,
      notes: '',
      status: EstadoCita.Programada,
      usuario: '',
    });

    setPatientFound(false);
  };

  const handleClose = () => {
    setVisible(false);
  };

  // Función para guardar la cita
  const handleSaveAppointment = async (formData) => {
    try {
      // Preparar datos para API
      const citaData: any = {
        Ct_Ag_Id: formData.agendaId,
        Ct_Pa_Id: formData.patientId || 0,
        Ct_Cz_Id: formData.quotationId,
        Ct_POrd_Id: preorderId,
        Ct_Notas: formData.notes,
        Ct_FechaAtencion: formData.startDate,
        Ct_FechaFinAtencion: formData.endDate,
        Ct_Estado: formData.status,
      };

      const result = await createCita(citaData);

      if (result) {
        handleClose();
      }
    } catch (error) {
      console.error('Error al guardar cita:', error);
      newToast('ERROR', 'Error al guardar la cita', 3);
    }
  };

  return <div>{appointmentFormData && <AppointmentForm visible={visible} formData={appointmentFormData} setFormData={setAppointmentFormData} isEditMode={false} isSearchingPatient={isSearchingPatient} setIsSearchingPatient={setIsSearchingPatient} patientFound={patientFound} setPatientFound={setPatientFound} agendas={agendas} onSave={handleSaveAppointment} onCancel={handleClose} initialPatientDocument={patientDocument} quotationId={quotationId} preorderId={preorderId}/>}</div>;
};
